var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading__box"}),_c('div',{staticClass:"loading__box"}),_c('div',{staticClass:"loading__box"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07b2a455","hasScoped":true,"transformToRequire":{"video":"src","source":["src","srcset"],"vector":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/loading-block/loading.block.vue
// module id = yRBS
// module chunks = 1